<template>

  <!-- eslint-disable  -->

  <div class="">

    <!-- currently open gallery -->

    <!-- galleries -->
    <div class="w-full text-left" v-if="this.$store.state.fetchGalleriesComplete == true">

      <h1 class="text-gray-800 text-4xl text-left mx-8 mt-8 mb-4"> Bildergalerien </h1>

      <!-- flexing the gallieres -->
      <div class="flex flex-wrap mx-2 sm:mx-4 px-2 sm:px-4 py-6 ">

        <!-- iterating galleries -->
        <div class="cursor-pointer mb-8 card w-full md:w-1/2 lg:w-1/3" :key="index.titel" v-for="index in sortGalleries">

          <div @click="opengallery(index.id)" class="rounded-lg mx-2 p-4 bg-blue-100  h-full">

            <!-- setting title -->
            <h1 class="text-xl text-blue-800 mb-2 md:h-16"> {{ index.titel }} </h1>

            <div v-if="index.galerie.length > 6" class="">

              <!-- flexing images inside gallieries -->
              <div class="flex flex-wrap flex-1">

                <!-- iterating the images -->

                <div class="w-1/2 sm:w-1/3 p-2" :key="image.id" v-for="image in index.galerie.slice(0,6)">

                  <img class="w-full h-32 object-cover" :src="image.url" alt="">

                </div>

              </div>

              <p class="mt-4" v-html="index.beschreibung">  </p>

            </div>

            <div v-else-if="index.galerie.length > 0" class="">

              <!-- flexing images inside gallieries -->
              <div class="flex flex-wrap flex-1">

                <!-- iterating the images -->

                <div class="w-1/2 sm:w-1/3 p-2" :key="image.id" v-for="image in index.galerie">

                  <img class="w-full h-32 object-cover" :src="image.url" alt="">

                </div>

              </div>

              <p class="mt-4" v-html="index.beschreibung">  </p>

            </div>

            <div v-else class="">

              <p> <i> Diese Bildergalerie enthält keine Bilder. </i> </p>

              <p class="mt-4" v-html="index.beschreibung">  </p>

            </div>

          </div>

        </div>

      </div>
    </div>

  </div>
</template>

<script>

export default {
  components: {


  },
  name: 'Galleries',
  props: {

  },
  data() {
    return {

      actualYear: '',
      actualDate: '',

    }
  },
  methods: {

    opengallery(id){

      // console.log("opening" + id);

      this.$store.commit('opengallery', id);

    },

    closegallery(){

      this.$store.commit('closegallery');

    },

    convert(old){

      // console.log("nodedate:" + old);

      var monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni",
      "Juli", "August", "September", "Oktober", "November", "Dezember"];

      // console.log(old)

      var yyyy = old.slice(0, 4)
      // console.log("Actual:" + yyyy);
      // console.log("This:" + this.actualYear)

      var mm = old.slice(4, 6)
      mm = parseInt(mm)

      var dd = old.slice(6, 8)

      if (yyyy == this.actualYear){
        return (dd + ". " + monthNames[mm-1] + " " + yyyy);
      } else {
        return (dd + ". " + monthNames[mm-1] + " " + yyyy);
      }
    },

    getdate(){
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();

      // console.log(today = dd + '. ' + monthNames[mm] + ' ' + yyyy);

      this.actualYear = yyyy;
      this.actualDate = yyyy + mm + dd

      // console.log("DATUM IST" + this.actualDate);
    },

    compare(a, b) {
      if (a.datum > b.datum) {
        return -1;
      }
      if (a.datum < b.datum) {
        return 1;
      }
      // a muss gleich b sein
      return 0;
    },

  },
  mounted: function(){

    this.getdate();

  },

  computed: {

    sortGalleries() {
      // console.log(this.data.slice().sort(this.compare));

      var sorted = this.$store.state.galleries.slice().sort(this.compare)

      return sorted
    },

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.container{
  width: 200px;
}

</style>
